package com.sddamico.swigmore.ds.forms

import androidx.compose.runtime.Composable
import com.sddamico.swigmore.ds.SwColor
import com.sddamico.swigmore.ds.SwEffects
import com.sddamico.swigmore.ds.SwType
import com.sddamico.swigmore.ds.css
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.dom.Option
import org.jetbrains.compose.web.dom.Select
import org.jetbrains.compose.web.dom.Text

/**
 * A native picker in the Form [TextField] look. [options] are value to label; [unavailable] values
 * are listed but greyed out (a team already on another ballot line).
 */
@Composable
fun SelectField(
  value: String?,
  onValueChange: (String?) -> Unit,
  options: List<Pair<String, String>>,
  placeholder: String,
  label: String,
  modifier: Modifier = Modifier,
  unavailable: Set<String> = emptySet(),
) {
  Select(
    attrs = Modifier
      .css("width" to "100%", "min-width" to "0", "box-sizing" to "border-box", "padding" to "12px",
        "border-radius" to SwEffects.radiusMd, "border" to "1.5px solid ${SwColor.borderOnCream}",
        "background" to SwColor.creamLight, "color" to SwColor.field700, "font" to "500 15px ${SwType.body}")
      .then(modifier)
      .toAttrs {
        attr("aria-label", label)
        onChange { event -> onValueChange(event.value?.ifEmpty { null }) }
      }
  ) {
    Option("", attrs = { if (value == null) selected() }) { Text(placeholder) }
    options.forEach { (optionValue, optionLabel) ->
      Option(optionValue, attrs = {
        if (optionValue == value) selected()
        if (optionValue != value && optionValue in unavailable) disabled()
      }) { Text(optionLabel) }
    }
  }
}
